import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({ name: 'dateonly' })
export class DateonlyPipe implements PipeTransform {

  transform(value: any, format: string = 'MM/DD/YYYY'): string {
    if (!value) return '';

    let date: moment.Moment;

    // UNIX seconds
    if (typeof value === 'number' && value.toString().length === 10) {
      date = moment.unix(value);
    }
    // UNIX milliseconds
    else if (typeof value === 'number' && value.toString().length === 13) {
      date = moment(value);
    }
    // ISO / Carbon / MySQL (including ...Z)
    else if (typeof value === 'string') {
      date = moment.parseZone(value);
    }
    else {
      return '';
    }

    if (!date.isValid()) return '';

    // Convert to local ONCE
    return date.local().format(format);
  }
}
